import React from "react";
import PropTypes from "prop-types";
import { verticalType } from "../../../types";
import DesktopFilter from "./DesktopFilter";
import MobileFilter from "./MobileFilter";

class FilterBar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isMobile: false
        };
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize);
        this.resize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }

    resize = () => {
        this.setState({
            isMobile: document.body.getBoundingClientRect().width <= 1024
        });
    };

    render() {
        const { isMobile } = this.state;
        const { vertical, copyData } = this.props;
        const { resources_link: resourcesLink, market, search: placeholder } = copyData;

        if (isMobile) {
            return (
                <MobileFilter
                    vertical={vertical}
                    market={market}
                    resourcesLink={resourcesLink}
                    placeholder={placeholder}
                />
            );
        }

        return (
            <DesktopFilter
                vertical={vertical}
                market={market}
                resourcesLink={resourcesLink}
                placeholder={placeholder}
            />
        );
    }
}

FilterBar.propTypes = {
    vertical: verticalType.isRequired,
    copyData: PropTypes.shape({
        resources_link: PropTypes.string.isRequired
    }).isRequired
};

export default FilterBar;
